import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setStep } from '../../store/formSlice';
import React from 'react';

const Stepper = React.memo(({ currentStep, totalSteps }) => {
    const dispatch = useDispatch();

    const handleStepClick = (stepNumber) => {
        // Only allow clicking on current step or previous steps
        if (stepNumber <= currentStep) {
            dispatch(setStep(stepNumber));
        }
        // Do nothing if trying to click on future steps
    };

    const getStepStyles = (stepNumber) => {
        const isCurrentStep = stepNumber === currentStep;
        const isPreviousStep = stepNumber < currentStep;
        // const isFutureStep = stepNumber > currentStep;

        return {
            bg: isCurrentStep || isPreviousStep ? "brand.500" : "gray.300",
            transition: "all 0.3s ease",
        };
    };

    return (
        <Box w="100%" position="relative" left="50%" right="50%" ml="-50vw" mr="-50vw" bg="transparent">
            <Flex
                justify="center"
                align="center"
                mt={4}
                mb={8}
                maxW={{ base: '90vw', md: '1200px' }}
                mx="auto"
                px={{ base: 2, md: 0 }}
            >
                {Array.from({ length: totalSteps }, (_, i) => {
                    const stepNumber = i + 1;
                    const stepStyles = getStepStyles(stepNumber);

                    return (
                        <Box
                            key={i}
                            h="6px"
                            w="13%"
                            borderRadius="full"
                            mx={1}
                            onClick={() => handleStepClick(stepNumber)}
                            {...stepStyles}
                        />
                    );
                })}
            </Flex>
        </Box>
    );
});

export default Stepper; 